import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Box from "@mui/material/Box";
import { Snackbar, Alert } from "@mui/material";
import { db, doc, setDoc } from "../../../../firebaseConfig";

import FileSizesV2 from "./FileSizesV2";

const ImageSpecsTab = ({ jobData, clientData, setHasUnsavedChanges }) => {
  const [jobTypeFull, setJobTypeFull] = useState(jobData?.jobTypeFull);

  useEffect(() => {
    setJobTypeFull(jobData.jobTypeFull);
  }, [jobData]);

  const [copyToClipboardSnackbarOpen, setCopyToClipboardSnackbarOpen] =
    useState(false);

  const updateFSCDB = debounce(async (id, field, value) => {
    await setDoc(doc(db, "ClientDatabase", id), { [field]: value }, { merge: true });
  }, 1200);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        type: "spring",
        stiffness: 300,
        damping: 30,
        mass: 1,
      }}
    >
      <Box sx={{ p: 1 }}>
        <FileSizesV2
          client={clientData}
          updateFS={updateFSCDB}
          filter={
            jobTypeFull?.includes("-L") || jobTypeFull?.includes("-R")
              ? "life"
              : jobTypeFull?.includes("-P") || jobTypeFull?.includes("-R")
              ? "product"
              : jobTypeFull?.includes("-V") || jobTypeFull?.includes("-E")
              ? "video"
              : false
          }
        />
      </Box>
      <Snackbar
        open={copyToClipboardSnackbarOpen}
        autoHideDuration={3000}
        onClose={() => setCopyToClipboardSnackbarOpen(false)}
      >
        <Alert elevation={6} variant="filled" severity="success">
          Settings copied to clipboard
        </Alert>
      </Snackbar>
    </motion.div>
  );
};

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export default ImageSpecsTab;